"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptableViewPanelFactory = exports.AdaptableViewFactory = void 0;
const tslib_1 = require("tslib");
const SmartEditPopup_1 = require("./SmartEdit/SmartEditPopup");
const QuickSearchPopup_1 = require("./QuickSearch/QuickSearchPopup");
const ThemePopup_1 = require("./Theme/ThemePopup");
const ToolPanelPopup_1 = require("./Components/ToolPanel/ToolPanelPopup");
const GridInfoPopup_1 = require("./GridInfo/GridInfoPopup/GridInfoPopup");
const DashboardPopup_1 = require("./Dashboard/DashboardPopup");
const StateManagementPopup_1 = require("./StateManagement/StateManagementPopup");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const BulkUpdatePopup_1 = require("./BulkUpdate/BulkUpdatePopup");
const CellSummaryPopup_1 = require("./CellSummary/CellSummaryPopup");
const SystemStatusPopup_1 = require("./SystemStatus/SystemStatusPopup");
const AlertViewPanel_1 = require("./Alert/AlertViewPanel");
const BulkUpdateViewPanel_1 = require("./BulkUpdate/BulkUpdateViewPanel");
const CellSummaryViewPanel_1 = require("./CellSummary/CellSummaryViewPanel");
const FilterViewPanel_1 = require("./Filter/FilterViewPanel");
const DashboardViewPanel_1 = require("./Dashboard/DashboardViewPanel");
const ExportViewPanel_1 = require("./Export/ExportViewPanel");
const LayoutViewPanel_1 = require("./Layout/LayoutViewPanel");
const GridFilterViewPanel_1 = require("./GridFilter/GridFilterViewPanel");
const QuickSearchViewPanel_1 = require("./QuickSearch/QuickSearchViewPanel");
const SmartEditViewPanel_1 = require("./SmartEdit/SmartEditViewPanel");
const SystemStatusViewPanel_1 = require("./SystemStatus/SystemStatusViewPanel");
const ThemeViewPanel_1 = require("./Theme/ThemeViewPanel");
const DataSetViewPanel_1 = require("./DataSet/DataSetViewPanel");
const DataChangeHistoryPopup_1 = require("./DataChangeHistory/DataChangeHistoryPopup");
const DataChangeHistoryViewPanel_1 = require("./DataChangeHistory/DataChangeHistoryViewPanel");
const StateManagementViewPanel_1 = require("./StateManagement/StateManagementViewPanel");
const StatusBarPopup_1 = require("./StatusBar/StatusBarPopup");
const ChartingViewPanel_1 = require("./Charting/ChartingViewPanel");
const GridFilterPopup_1 = require("./GridFilter/GridFilterPopup");
const ColumnInfoPopup_1 = require("./ColumnInfo/ColumnInfoPopup");
const NotesListing_1 = require("./Notes/NotesListing");
const DataImportPopup_1 = require("./DataImport/DataImportPopup");
exports.AdaptableViewFactory = {
    BulkUpdatePopup: BulkUpdatePopup_1.BulkUpdatePopup,
    DashboardPopup: DashboardPopup_1.DashboardPopup,
    StateManagementPopup: StateManagementPopup_1.StateManagementPopup,
    GridInfoPopup: GridInfoPopup_1.GridInfoPopup,
    ColumnInfoPopup: ColumnInfoPopup_1.ColumnInfoPopup,
    StatusBarPopup: StatusBarPopup_1.StatusBarPopup,
    QuickSearchPopup: QuickSearchPopup_1.QuickSearchPopup,
    CellSummaryPopup: CellSummaryPopup_1.CellSummaryPopup,
    SmartEditPopup: SmartEditPopup_1.SmartEditPopup,
    ThemePopup: ThemePopup_1.ThemePopup,
    ToolPanelPopup: ToolPanelPopup_1.ToolPanelPopup,
    SystemStatusPopup: SystemStatusPopup_1.SystemStatusPopup,
    DataChangeHistoryPopup: DataChangeHistoryPopup_1.DataChangeHistoryPopup,
    NotesPopup: NotesListing_1.NotesListing,
    DataImportPopup: DataImportPopup_1.DataImportPopup,
    GridFilterPopup: GridFilterPopup_1.GridFilterPopup,
};
exports.AdaptableViewPanelFactory = new Map([
    [ModuleConstants.AlertModuleId, AlertViewPanel_1.AlertViewPanelControl],
    [ModuleConstants.BulkUpdateModuleId, BulkUpdateViewPanel_1.BulkUpdateViewPanelControl],
    [ModuleConstants.CellSummaryModuleId, CellSummaryViewPanel_1.CellSummaryViewPanelControl],
    [ModuleConstants.ColumnFilterModuleId, FilterViewPanel_1.FilterViewPanelControl],
    [ModuleConstants.DashboardModuleId, DashboardViewPanel_1.DashboardViewPanelControl],
    [ModuleConstants.ExportModuleId, ExportViewPanel_1.ExportViewPanelControl],
    [ModuleConstants.LayoutModuleId, LayoutViewPanel_1.LayoutViewPanelControl],
    [ModuleConstants.GridFilterModuleId, GridFilterViewPanel_1.GridFilterPanelControl],
    [ModuleConstants.QuickSearchModuleId, QuickSearchViewPanel_1.QuickSearchViewPanelControl],
    [ModuleConstants.SmartEditModuleId, SmartEditViewPanel_1.SmartEditViewPanelControl],
    [ModuleConstants.SystemStatusModuleId, SystemStatusViewPanel_1.SystemStatusViewPanel],
    [ModuleConstants.ThemeModuleId, ThemeViewPanel_1.ThemeViewPanelControl],
    [ModuleConstants.DataSetModuleId, DataSetViewPanel_1.DataSetViewPanelControl],
    [ModuleConstants.DataChangeHistoryModuleId, DataChangeHistoryViewPanel_1.DataChangeHistoryViewPanelControl],
    [ModuleConstants.StateManagementModuleId, StateManagementViewPanel_1.StateManagementViewPanel],
    [ModuleConstants.ChartingModuleId, ChartingViewPanel_1.ChartingViewPanel],
]);
